import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { BaseSocialShareButton } from '../base-social-share-button/base-social-share-button';
import { MailIcon } from '../../icons';

interface IMailShareButtonProps {
  size?: 'large' | 'small';
  subject?: string;
  body?: string;
  showButton: boolean;
}

export const MailShareButton = inject('state', 'dispatch')(observer((props: IMailShareButtonProps & IInjectedProps) => {
  return (
    <BaseSocialShareButton
      backgroundColor={props.state.colors.ContentColor}
      icon={<MailIcon/>}
      text="Mail"
      size={props.size}
      showButton={props.showButton}
      onClick={() => {
        props.dispatch.sendEmail('', props.subject, props.body);
      }}
    />
  );
}));
